<template>
  <div>
    <div
      class="flex justify-start  w-full items-center  mb-2 pr-2 space-x-4 py-1"
    >
      <div
        class="w-full bg-rounded-md flex items-center justify-start border-2 rounded-md border-black pl-2"
      >
        <img src="/icons/search.png" alt="magnify" class="w-[24px] pr-2" />
        <input
          type="text"
          v-model="search"
          placeholder="Search"
          class="py-1 w-full pl-2 outline-none rounded-md"
        />
      </div>
      <div><v-btn @click="refresh">Refresh Table</v-btn></div>
    </div>
    <div class="md:flex menuWrapper">
      <div class="w-full">
        <v-progress-linear :indeterminate="progressBar"></v-progress-linear>
        <v-data-table
          class="no-data-table-rows-hover w-full"
          hide-default-header
          dense
          :headers="headers"
          :items="dataTableItems"
          :search="search"
        >
          <template v-slot:header>
            <thead>
              <tr>
                <th class="bg-[#44546A] text-left px-4 py-2 textStyle">Row</th>
                <th
                  class="bg-[#44546A] text-left px-4 py-2 textStyle"
                  style="width: 150px;"
                >
                  Ticket No.
                </th>
                <th class="textStyle bg-[#44546A] text-left px-4 py-2">Date</th>
                <th class="textStyle bg-[#44546A] text-left px-4 py-2">
                  Buyer
                </th>
                <th class="textStyle bg-[#44546A] text-left px-4 py-2">
                  Classification
                </th>
                <th class="textStyle bg-[#44546A] text-left px-4 py-2">
                  Subject
                </th>
                <th class="textStyle bg-[#44546A] text-left px-4 py-2">
                  Contract No.
                </th>
                <th
                  v-if="$route.path.includes('/updated-bis')"
                  class="textStyle bg-[#44546A] text-left px-4 py-2"
                >
                  Attachments
                </th>
                <th class="textStyle bg-[#44546A] text-left px-4 py-2">
                  Action
                </th>
              </tr>
            </thead>
          </template>
          <!-- Custom Item Slot -->
          <template v-slot:item="{ item }">
            <tr
              :class="[
                item.is_read === 0
                  ? ''
                  : $route.path.includes('/unassigned-tickets')
                  ? 'text-black font-extrabold'
                  : '',
                markedRows.includes(item.ticket_id) ? '' : '',
              ]"
            >
              <td class="align-top px-4 py-2">
                <div class="flex items-center justify-start space-x-2">
                  <div
                    :class="
                      markedRows.includes(item.ticket_id)
                        ? 'marked-circle'
                        : 'unmarked-circle'
                    "
                    class="rounded-full w-4 h-4 flex items-center justify-center"
                  >
                    <span class="text-xl">&bull;</span>
                  </div>
                  <div>
                    <v-btn
                      v-if="$route.path.includes('/unassigned-tickets')"
                      @click="checkTicketId(item)"
                    >
                      {{ item.ticket_id }}</v-btn
                    >
                    <div v-else>{{ item.ticket_id }}</div>
                  </div>
                </div>
              </td>

              <td class="align-top px-4 py-2" style="width: 150px;">
                {{ item.moldex_ticket_number }}
              </td>
              <td class="align-top px-4 py-2">{{ moment(item.reg_date) }}</td>
              <td class="align-top px-4 py-2">{{ item.buyer_name }}</td>
              <td class="align-top px-4 py-2">{{ item.classification }}</td>
              <td class="align-top px-4 py-2">{{ item.subject }}</td>
              <td class="align-top px-4 py-2">{{ item.contract_number }}</td>
              <td
                v-if="$route.path.includes('/updated-bis')"
                class="align-top px-4 py-2"
              >
                <div
                  v-if="
                    item.attachments.attachment1 ||
                      item.attachments.attachment2 ||
                      item.attachments.attachment3
                  "
                >
                  <v-btn small @click="viewAttachment(item)">Attachments</v-btn>
                </div>
                <div v-else>
                  none
                </div>
              </td>
              <td class="align-top px-4 py-2 space-y-1">
                <button
                  v-if="
                    !$route.path.includes('/closed-bis') &&
                      !$route.path.includes('/closed-tickets')
                  "
                  :class="buttonStyle"
                  @click="toggleMarkAsUnread(item.ticket_id)"
                >
                  {{
                    markedRows.includes(item.ticket_id)
                      ? "Mark as read"
                      : "Mark as unread"
                  }}
                </button>
                <button :class="buttonStyle" @click="openSelectedRow(item)">
                  View Ticket
                </button>
                <!-- <button :class="buttonStyle" @click="openToAssign(item)">
                  Assign
                </button> -->
                <button
                  v-if="$route.meta.id != 12"
                  :class="buttonStyle"
                  @click.stop="openDialogCloseTicket(item)"
                >
                  Close Ticket
                </button>
                <button v-else :class="buttonStyle" @click="reOpenTicket(item)">
                  Reopen Ticket
                </button>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </div>
    <TicketDialog
      v-if="$route.path.includes('/unassigned-tickets')"
      @closeDialog="closeDialog"
      :selectedItemInfo="selectedItemInfo"
      :showDialog="showDialog"
      :notification_history="notification_history"
      :csvInfo="csvInfo"
      :classification_id="classification_id"
    />
    <TicketDialog
      v-if="$route.path.includes('/closed-tickets')"
      @closeDialog="closeDialog"
      :selectedItemInfo="selectedItemInfo"
      :showDialog="showDialog"
      :notification_history="notification_history"
      :csvInfo="csvInfo"
      :classification_id="classification_id"
    />
    <TicketDialogBis
      v-if="$route.path.includes('/updated-bis')"
      @closeDialog="closeDialog"
      :selectedItemInfo="selectedItemInfo"
      :showDialog="showDialog"
      :notification_history="notification_history"
      :classification_id="classification_id"
    />
    <TicketDialogBis
      v-if="$route.path.includes('/closed-bis')"
      @closeDialog="closeDialog"
      :selectedItemInfo="selectedItemInfo"
      :showDialog="showDialog"
      :notification_history="notification_history"
      :classification_id="classification_id"
    />

    <div>
      <AssignDialog
        class="bg-white"
        :openAssignDialog="openAssignDialog"
        @assignSubmitted="assignSubmitted"
        @closeAssignDialog="closeAssignDialog"
      />
    </div>
    <v-dialog
      v-model="viewAttachmentDialog"
      :overlay="false"
      max-width="800px"
      transition="dialog-transition"
    >
      <BisAttachment
        :selectedAttachments="selectedAttachments"
        @closeAttachmentDialog="closeAttachmentDialog"
      />
    </v-dialog>
    <v-dialog
      v-if="$route.meta.title != 'Closed Tickets'"
      v-model="dialogCloseTicket"
      persistent
      :overlay="true"
      max-width="400px"
      transition="dialog-transition"
    >
      <v-card class="p-2">
        <v-card-title primary-title>
          Notice
        </v-card-title>
        <v-card-text> Close ticket id:{{ ticketIdToClose }}? </v-card-text>
        <v-card-actions class="mx-4">
          <v-btn @click="cancelCloseTicket">Cancel</v-btn>
          <v-btn @click="closeTicket(selectedItemInfo)">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AssignDialog from "../components/AssignDialog.vue";
import axios from "axios";
import TicketDialog from "../components/TicketDialog.vue";
import TicketDialogBis from "../components/TicketDialogBis.vue";
import moment from "moment";
import BisAttachment from "../components/BisAttachmentsPage.vue";

export default {
  props: ["keySearch"],
  components: { AssignDialog, TicketDialog, TicketDialogBis, BisAttachment },
  data() {
    return {
      ticketIdToClose: null,
      isUnread: false,
      selectedAttachments: [],
      markedRows: [],
      buttonStyle:
        "bg-gray-200 rounded-md px-4 w-full hover:bg-[#44546A] hover:text-white",
      progressBar: false,
      csvInfo: [],
      classification_id: "",
      notification_history: [],
      dialogCloseTicket: false,
      viewAttachmentDialog: false,
      viewAttachmentUrl: "",
      selectedItemInfo: {},
      ticket_id_selected: null,
      search: "",
      openAssignDialog: false,
      showDialog: false,
      dataTableItems: [],
      headers: [
        {
          text: "Row",
          value: "ticket_id",
          class: "thead1",
        },
        {
          text: "Ticket No.",
          value: "moldex_ticket_number",
          class: "thead1",
        },
        {
          text: "Date",
          value: "reg_date",
          class: "thead1",
        },
        {
          text: "Buyer",
          value: "buyer_name",
          class: "thead1",
        },
        {
          text: "Classification",
          value: "classification",
          class: "thead1",
        },
        {
          text: "Subject",
          value: "subject",
          class: "thead1",
        },

        {
          text: "Contract No.",
          value: "contract_number",
          class: "thead1",
        },
        // {
        //   text: "Ticket Location",
        //   value: "location",
        //   class: "thead1",
        // },
        {
          text: "Attachments",
          value: "attachments",
          class: "thead1",
        },
        {
          text: "Action",
          value: "actions",
          class: "thead1",
        },
      ],
    };
  },

  computed: {
    serverUrl() {
      return this.axios.defaults.baseURL;
    },
  },
  watch: {
    "$route.meta.id": {
      immediate: true,
      async handler(e) {
        if (e == 0) {
          this.getTickets();
        } else if (e == 10) {
          this.getBISTickets();
        } else if (e == 12) {
          this.getClosedTickets();
        } else if (e == 99) {
          this.getWatchList();
        } else if (e == 100) {
          this.getClosedBis();
        } else {
          this.postTickets(e);
        }
      },
    },
  },
  mounted() {},
  methods: {
    toggleMarkAsUnread(rowId) {
      const ticket = this.dataTableItems.find(
        (item) => item.ticket_id === rowId
      );

      // Toggle the is_read status
      ticket.is_read = ticket.is_read ? 0 : 1;

      // Update the markedRows array based on the is_read status
      if (ticket.is_read) {
        // If the ticket is marked as read (1), add it to markedRows
        this.markedRows.push(rowId);
      } else {
        // If the ticket is marked as unread (0), remove it from markedRows
        this.markedRows = this.markedRows.filter((id) => id !== rowId);
      }

      // Update the backend to reflect the new is_read status
      this.updateReadStatus(rowId, ticket.is_read);
    },

    refresh() {
      this.search = "";
      const route_name = this.$route.name;
      if (route_name == "unassigned-tickets") {
        this.getTickets();
      } else if (route_name == "closed-tickets") {
        this.getClosedTickets();
      } else if (route_name == "updated-bis") {
        this.getBISTickets();
      } else if (route_name == "closed-bis") {
        this.getClosedBis();
      } else if (route_name == "watch-list") {
        this.getWatchList();
      }
      this.$toast.success("Table refreshed successfully!");
    },
    closeAttachmentDialog() {
      this.viewAttachmentDialog = false;
    },
    async updateReadStatus(ticketId, isRead) {
      try {
        await axios.post("/tickets/update-status", {
          ticketId: ticketId,
          is_read: isRead,
        });
      } catch (error) {
        console.error("Error updating read status:", error);
      }
    },

    async checkTicketId(item) {
      const data = {
        ticket_id: item.ticket_id,
      };
      axios
        .post("/tickets/checkForMissingCt", data)
        .then(async (res) => {
          if (res.data.status) {
            this.getTickets();
            alert(res.data.message);
          } else {
            alert(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // async checkTicketsForEmpty() {
    //   await axios.get("/tickets/check_tickets");
    // },

    // function to separate base from path
    separateUrl(fullUrl) {
      // Splitting the URL to handle the case of double slashes after the domain
      const parts = fullUrl.split("//", 3); // Split into at most 3 parts

      let baseUrl, path;
      if (parts.length === 3) {
        // If there are exactly 3 parts, it means there was a double slash
        baseUrl = parts[0] + "//" + parts[1]; // Combine the first two parts to form the base URL
        path = "/" + parts[2]; // The third part is the path, ensure it starts with a slash
      } else {
        // If the URL doesn't have double slashes, return it as is
        baseUrl = fullUrl;
        path = "";
      }

      return { baseUrl, path };
    },
    viewAttachment(item) {
      this.selectedAttachments = [
        item.attachments.attachment1,
        item.attachments.attachment2,
        item.attachments.attachment3,
      ].filter(Boolean); // Filter out any undefined/null values
      this.viewAttachmentDialog = true;
    },

    // closeTicket(item) {
    //   // Close all other dialogs first
    //   this.showDialog = false;
    //   this.viewAttachmentDialog = false;
    //   this.openAssignDialog = false;

    //   // Then open the close ticket dialog
    //   this.dialogCloseTicket = true;
    //   this.selectedItemInfo = item;
    // },
    cancelCloseTicket() {
      this.ticketIdToClose = null;
      this.dialogCloseTicket = false;
    },
    openDialogCloseTicket(item) {
      this.dialogCloseTicket = true;
      this.ticketIdToClose = item.ticket_id;
    },

    closeTicket() {
      let data = {
        ticket_id: this.ticketIdToClose,
      };

      axios
        .post("/tickets/ticket-closed", data)
        .then(() => {
          // Only after successful API call, clean up the state
          this.selectedItemInfo = null;
          this.showDialog = false;
          this.viewAttachmentDialog = false;
          this.openAssignDialog = false;
          this.dialogCloseTicket = false;

          // Refresh the table data
          this.getTickets();
        })
        .catch((err) => {
          console.error("Error closing ticket:", err);
          alert("Failed to close ticket. Please try again.");
        });
    },

    moment(d) {
      return moment(d).format("LLL");
    },
    assignSubmitted(item) {
      this.openAssignDialog = false;
      let data = {
        department_id: item,
        ticket_id: this.ticket_id_selected,
      };
      axios
        .post("/tickets/ticket-assignment", data)
        .then((res) => {
          alert(res.data.message);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    reOpenTicket(item) {
      let data = {
        ticket_id: item.ticket_id,
      };
      axios
        .post("/tickets/ticket-reopen", data)
        .then(() => {
          this.dialogCloseTicket = false;
          alert(
            "The ticket " + item.ticket_id + " has been successfully reopened."
          );
          this.getClosedTickets();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    closeAssignDialog() {
      this.openAssignDialog = false;
    },
    closeDialog() {
      this.showDialog = false;
      this.selectedItemInfo = {};
    },
    openToAssign(item) {
      this.openAssignDialog = true;
      this.ticket_id_selected = item.ticket_id;
    },

    async getCsvInfo(customerCode, contractNumber) {
      try {
        const info = {
          customer_code: customerCode,
          contract_number: contractNumber,
        };
        const res = await axios.post("/cs_data/get-contract-info", info);
        this.csvInfo = Array.isArray(res.data) ? res.data : []; // Ensure it's an array
      } catch (error) {
        console.error("Error fetching CSV Info:", error);
        this.csvInfo = []; // Fallback to an empty array on error
      }
    },
    async openSelectedRow(selected_row) {
      console.log("SELECTED ROW", selected_row);
      this.progressBar = true;
      this.selectedItemInfo = selected_row;
      this.classification_id = selected_row.classification_id;

      this.getNotificationHistory(selected_row.ticket_id);
      await this.getCsvInfo(
        selected_row.customer_code,
        selected_row.contract_number
      );
      this.progressBar = false;
      this.showDialog = true;
    },
    getNotificationHistory(ticket_id) {
      let data = {
        ticket_id: ticket_id,
      };
      axios.post("/history/get", data).then((res) => {
        this.notification_history = res.data;
        console.log("this.notification_history", this.notification_history)
      });
    },
    getClosedTickets() {
      this.progressBar = true;
      axios.get("/tickets/getClosedTickets").then((res) => {
        this.dataTableItems = res.data;
        this.progressBar = false;
      });
    },
    getClosedBis() {
      axios.get("/tickets/getClosedBis").then((res) => {
        this.dataTableItems = res.data;
      });
    },
    async getBISTickets() {
      this.progressBar = true;
      try {
        const res = await axios.get("/bis");
        this.dataTableItems = res.data.map((ticket) => ({
          ...ticket,
          is_read: ticket.is_read || 0, // Ensure is_read is set to 0 if undefined
          buyer_name: `${ticket.firstname} ${ticket.lastname}`,
          attachments: {
            attachment1: `${ticket.id1_filepath}`,
            attachment2: `${ticket.id1_filepath}`,
            attachment3: `${ticket.id1_filepath}`,
          },
        }));
        this.markedRows = this.dataTableItems
          .filter((ticket) => ticket.is_read === 1)
          .map((ticket) => ticket.ticket_id);
        this.progressBar = false;
      } catch (error) {
        this.progressBar = false;
        console.error("Error fetching BIS tickets:", error);
      }
    },
    async getTickets() {
      try {
        this.progressBar = true;
        const res = await axios.get("/tickets/unassigned");
        this.dataTableItems = res.data.map((ticket) => ({
          ...ticket,
          is_read: ticket.is_read || 0, // Ensure is_read is set to 0 if undefined
        }));
        // Populate markedRows based on is_read
        this.markedRows = this.dataTableItems
          .filter((ticket) => ticket.is_read === 1)
          .map((ticket) => ticket.ticket_id);
        this.progressBar = false;
      } catch (error) {
        this.progressBar = false;
        console.error("Error fetching tickets:", error);
      }
    },
    async getWatchList() {
      const res = await axios.get("/tickets/watchlist");
      this.dataTableItems = res.data;
    },
    postTickets(n) {
      let data = {
        department_id: n,
      };
      axios.post("/tickets/get-assigned", data).then((res) => {
        this.dataTableItems = res.data;
      });
    },
  },
};
</script>

<style>
.MenuWrapper {
  background: rgb(35, 35, 35);
  background: linear-gradient(
    156deg,
    rgba(35, 35, 35, 1) 0%,
    rgba(8, 133, 42, 1) 58%,
    rgba(62, 160, 89, 1) 76%,
    rgba(101, 179, 122, 1) 92%
  );
}
.buttons {
  background: rgb(72, 72, 72);
  background: linear-gradient(
    156deg,
    rgba(72, 72, 72, 1) 37%,
    rgba(117, 117, 117, 1) 77%
  );
}

.marked-circle {
  background-color: black;
  color: white;
}

.unmarked-circle {
  background-color: transparent;
  color: black;
}

.no-data-table-rows-hover .v-data-table__wrapper tbody tr:hover {
  background-color: transparent !important;
}

.textStyle {
  color: white !important;
}
</style>
